export default {
  computed: {
    marginClasses() {
      const regex = /^m([t,b])/i
      const { containerMarginTop, containerMarginBottom } = this.attributes
      return `${containerMarginTop ? `${String(containerMarginTop).replace(regex, 'm$1-')}` : ''}${
        containerMarginBottom ? ` ${String(containerMarginBottom).replace(regex, 'm$1-')}` : ''
      }`
    },
  },
}
